"use client";

import Context from "@/context/Context";
import AnnouncementBar from "@/components/Header/AnnouncementBar";
import HeaderDashboard from "@/components/Header/HeaderDashboard";
import PopupMobileMenu from "@/components/Header/PopUpMobileMenu";
import Contact from "@/components/Contact/Contact";
import Footer from "@/components/Footers/Footer";
import HomeChatSwitcher from "@/components/Common/HomeChatSwitcher";

const ContactClient = () => (
  <main className="page-wrapper rbt-dashboard-page">
    <Context>
      <div className="rbt-panel-wrapper">
        <AnnouncementBar />
        <HeaderDashboard display="d-none" />
        <PopupMobileMenu />
        <Contact />
        <Footer />
        <HomeChatSwitcher />
      </div>
    </Context>
  </main>
);

export default ContactClient;
